<template>
  <div class="top_nav_container">
    <div class="max-w-[1820px] mx-auto md:grid flex justify-between top_nav_menu_wrapper">
      <router-link to="/home">
        <img src="@/assets/img/logo.svg" alt="총회교육개발원">
      </router-link>

      <div class="flex justify-evenly items-center max-md:hidden">
        <div class="top_nav_cates">
          <router-link to="/introduce/1" class="nanum-square">소개</router-link>
          <div>
            <router-link to="/introduce/1">인사말</router-link>
            <router-link to="/introduce/2">총회교육 정신</router-link>
            <router-link to="/introduce/3">총회교육 사역</router-link>
            <router-link to="/introduce/4">섬기는 이들</router-link>
            <router-link to="/introduce/5">찾아오시는 길</router-link>
          </div>
        </div>
        
        <div class="top_nav_cates">
          <router-link to="/" class="nanum-square">컨퍼런스</router-link>

        </div>

        <div class="top_nav_cates">
          <router-link to="/mall" class="nanum-square">콘텐츠 몰</router-link>
          <div>
            <router-link to="/mall">콘텐츠 몰</router-link>
            <router-link to="/mypage/cart">콘텐츠 장바구니</router-link>
            <router-link to="/mypage/contentsBox">콘텐츠 보관함</router-link>
          </div>
        </div>

        <div class="top_nav_cates">
          <router-link to="/community/1" class="nanum-square">커뮤니티</router-link>
          <div>
            <router-link to="/community/1">공지사항</router-link>
            <router-link to="/community/2">자유게시판</router-link>
            <router-link to="/community/3">Q&A</router-link>
            <router-link to="/community/4">총회교육 웹진</router-link>
          </div>
        </div>
      </div>

      <aside class="flex justify-end gap-5 items-center max-lg:gap-1">
        <div class="max-lg:hidden flex gap-5 items-center">
          <router-link to="/mypage/cart" class="relative">
            <span :class="cartCount > 0 ? 'inline-block' : 'hidden'"
              class="cartCntSpan absolute rounded-full px-3 text-white text-sm bg-[#FF4A4A]"
              style="transform: translate(50%, -50%);">
              {{this.cartCount}}
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M0 4.375C0 4.14294 0.0921872 3.92038 0.256282 3.75628C0.420376 3.59219 0.642936 3.5 0.875 3.5H3.5C3.69518 3.50005 3.88474 3.56536 4.03853 3.68554C4.19232 3.80572 4.30152 3.97387 4.34875 4.16325L5.0575 7H25.375C25.5079 7.00004 25.6391 7.03035 25.7585 7.08864C25.878 7.14693 25.9826 7.23167 26.0644 7.33642C26.1462 7.44117 26.203 7.56318 26.2307 7.69319C26.2583 7.8232 26.2559 7.95779 26.2237 8.08675L23.5987 18.5868C23.5515 18.7761 23.4423 18.9443 23.2885 19.0645C23.1347 19.1846 22.9452 19.2499 22.75 19.25H7C6.80482 19.2499 6.61526 19.1846 6.46147 19.0645C6.30768 18.9443 6.19848 18.7761 6.15125 18.5868L2.8175 5.25H0.875C0.642936 5.25 0.420376 5.15781 0.256282 4.99372C0.0921872 4.82962 0 4.60706 0 4.375ZM5.495 8.75L7.6825 17.5H22.0675L24.255 8.75H5.495ZM8.75 22.75C8.28587 22.75 7.84075 22.9344 7.51256 23.2626C7.18437 23.5908 7 24.0359 7 24.5C7 24.9641 7.18437 25.4092 7.51256 25.7374C7.84075 26.0656 8.28587 26.25 8.75 26.25C9.21413 26.25 9.65925 26.0656 9.98744 25.7374C10.3156 25.4092 10.5 24.9641 10.5 24.5C10.5 24.0359 10.3156 23.5908 9.98744 23.2626C9.65925 22.9344 9.21413 22.75 8.75 22.75ZM5.25 24.5C5.25 23.5717 5.61875 22.6815 6.27513 22.0251C6.9315 21.3687 7.82174 21 8.75 21C9.67826 21 10.5685 21.3687 11.2249 22.0251C11.8813 22.6815 12.25 23.5717 12.25 24.5C12.25 25.4283 11.8813 26.3185 11.2249 26.9749C10.5685 27.6313 9.67826 28 8.75 28C7.82174 28 6.9315 27.6313 6.27513 26.9749C5.61875 26.3185 5.25 25.4283 5.25 24.5ZM21 22.75C20.5359 22.75 20.0908 22.9344 19.7626 23.2626C19.4344 23.5908 19.25 24.0359 19.25 24.5C19.25 24.9641 19.4344 25.4092 19.7626 25.7374C20.0908 26.0656 20.5359 26.25 21 26.25C21.4641 26.25 21.9092 26.0656 22.2374 25.7374C22.5656 25.4092 22.75 24.9641 22.75 24.5C22.75 24.0359 22.5656 23.5908 22.2374 23.2626C21.9092 22.9344 21.4641 22.75 21 22.75ZM17.5 24.5C17.5 23.5717 17.8687 22.6815 18.5251 22.0251C19.1815 21.3687 20.0717 21 21 21C21.9283 21 22.8185 21.3687 23.4749 22.0251C24.1313 22.6815 24.5 23.5717 24.5 24.5C24.5 25.4283 24.1313 26.3185 23.4749 26.9749C22.8185 27.6313 21.9283 28 21 28C20.0717 28 19.1815 27.6313 18.5251 26.9749C17.8687 26.3185 17.5 25.4283 17.5 24.5Z" fill="#1B1D21"/>
            </svg>
          </router-link>
          <div>
            <!-- <router-link to="/">
              진행중인 강의 <b>0</b>
            </router-link>
            <span class="mx-2">·</span> -->
            <router-link to="/mypage/contentsBox" class="ml-2">
              콘텐츠 보관함
            </router-link>
          </div>
        </div>

        <!-- 마이페이지 -->
        <VDialog v-if="!$store.state.uid.id" no-scroll :classes="{ bg: 'bg-black-alpha' }">
          <template #toggle="{ bind, on }">
            <button v-bind="bind" v-on="on" class="flex flex-col">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M20 9C21.4587 9 22.8576 9.57946 23.8891 10.6109C24.9205 11.6424 25.5 13.0413 25.5 14.5C25.5 15.9587 24.9205 17.3576 23.8891 18.3891C22.8576 19.4205 21.4587 20 20 20C18.5413 20 17.1424 19.4205 16.1109 18.3891C15.0795 17.3576 14.5 15.9587 14.5 14.5C14.5 13.0413 15.0795 11.6424 16.1109 10.6109C17.1424 9.57946 18.5413 9 20 9ZM20 22.75C26.0775 22.75 31 25.2113 31 28.25V31H9V28.25C9 25.2113 13.9225 22.75 20 22.75Z" fill="#1B1D21"/>
              </svg>
            </button>
          </template>
      
          <template #default="{ close }">
            <div class="bg-black bg-opacity-25 w-screen h-screen flex justify-center items-center">
              <div class="min-w-[25vw] flex flex-col bg-white w-fit rounded-3xl">
                <button
                  aria-label="close"
                  class="my-dialog__close w-fit mt-3 mr-4 self-end"
                  @click="close"
                >
                  <h4 class="text-2xl"><font-awesome-icon icon="fa-solid fa-circle-xmark" /></h4>
                </button>
                <div class="login max-lg:border-b border-neutral-300" :class="{ 'bg-sky-50' : isMenuVisible}">
                  <div class="login_inputs max-w-[658px] mx-auto py-5 px-5">
                    <div class="rounded-t-lg overflow-hidden outline outline-1 outline-[#bfdef2]">
                      <input type="text" class="p-4 w-full" placeholder="아이디" v-model="state.form.uid"/>
                    </div>
                    <div class="mt-[1px] rounded-b-lg overflow-hidden outline outline-1 outline-[#bfdef2]">
                      <input type="password" class="p-4 w-full" placeholder="비밀번호" v-model="state.form.upw" @keyup.enter="submit()" />
                    </div>
  
                    <div class="mt-2 mb-5 pb-5">
                      <button class="sec_blue_btn !rounded-full w-full p-4 border border-[#0090ec]" @click="submit()">
                        <h6 class="font-medium">로그인</h6>
                      </button>
                    </div>
        
                    <div class="flex justify-center items-center gap-2 leading-none md:text-sm">
                      <!-- <a href="" class="hover:underline">아이디/비밀번호 찾기</a> -->
                      <!-- <span class="block bg-black w-[1px] h-[0.8em]"></span> -->
                      <router-link to="/signup" class="hover:underline">회원가입</router-link>
                    </div>
              
                    <!-- 간편 로그인 -->
                    <div>
                      <p class="lg:mt-6 mt-4 text-center font-medium text-[#0090ec]">간편로그인 및 회원가입</p>
                      <div class="flex justify-center pt-4 gap-4">    
                        <naverLoginComponent />
                        <kakaoLoginComponent />
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </template>
        </VDialog>

        <div class="!w-fit top_nav_cates" v-else>
          <router-link to="/mypage">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M20 9C21.4587 9 22.8576 9.57946 23.8891 10.6109C24.9205 11.6424 25.5 13.0413 25.5 14.5C25.5 15.9587 24.9205 17.3576 23.8891 18.3891C22.8576 19.4205 21.4587 20 20 20C18.5413 20 17.1424 19.4205 16.1109 18.3891C15.0795 17.3576 14.5 15.9587 14.5 14.5C14.5 13.0413 15.0795 11.6424 16.1109 10.6109C17.1424 9.57946 18.5413 9 20 9ZM20 22.75C26.0775 22.75 31 25.2113 31 28.25V31H9V28.25C9 25.2113 13.9225 22.75 20 22.75Z" fill="#1B1D21"/>
            </svg>
          </router-link>
          <div class="max-md:!hidden">
            <router-link to="/mypage">마이페이지</router-link>
            <router-link to="/mypage/cart">장바구니</router-link>
            <router-link v-if="$store.state.level.id === 10" to="/management">컨퍼런스 관리자</router-link>
            <a v-if="$store.state.level.id === 10" href="http://eduwind-admin.node-www.com/sign" target="_blank">콘텐츠몰 관리자</a>
            <a class="cursor-pointer" @click="logout()">로그아웃</a>
          </div>
        </div>

        <!-- 메뉴 -->
        <button @click="toggleMenu()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M5 30V26.6667H35V30H5ZM5 21.6667V18.3333H35V21.6667H5ZM5 13.3333V10H35V13.3333H5Z" fill="#1B1D21"/>
          </svg>
        </button>
      </aside>
    </div>
  </div>

  <!-- 메뉴 -->
  <div
    v-if="isMenuVisible" 
    class="fixed w-full top-0 right-0 h-full bg-white border-l border-neutral-200 p-6 z-50 md:w-[24.3%] md:min-w-[28.125rem] md:p-[2vw]">
    <div class="grid">
      <button type="button" @click="toggleMenu()" style="justify-self: flex-end;">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M1 1L21 21" stroke="black" stroke-width="1.5"/>
          <path d="M21 1L1 21" stroke="black" stroke-width="1.5"/>
        </svg>
      </button>
    </div>

    <!-- <img src="@/assets/img/logo_txt.svg" class="my-16"/> -->

    <div class="mt-8">
      <div class="mb-10 top_nav_menu">
        <h4 class="font-bold">소개</h4>
        <router-link to="/introduce/1">인사말</router-link>
        <router-link to="/introduce/2">총회교육 정신</router-link>
        <router-link to="/introduce/3">총회교육 사역</router-link>
        <router-link to="/introduce/4">섬기는 이들</router-link>
        <router-link to="/introduce/5">찾아오시는 길</router-link>
      </div>
  
      <div class="mb-10 top_nav_menu">
        <h4 class="font-bold">컨퍼런스</h4>
      </div>
  
      <div class="mb-10 top_nav_menu">
        <h4 class="font-bold">콘텐츠 몰</h4>
        <router-link to="/mall">콘텐츠 몰</router-link>
        <router-link to="/mypage/cart">콘텐츠 장바구니</router-link>
        <router-link to="/mypage/contentsBox">콘텐츠 보관함</router-link>
      </div>
  
      <div class="mb-10 top_nav_menu">
        <h4 class="font-bold">커뮤니티</h4>
        <router-link to="/community/1">공지사항</router-link>
        <router-link to="/community/2">자유게시판</router-link>
        <router-link to="/community/3">Q&A</router-link>
        <router-link to="/community/4">총회교육 웹진</router-link>
      </div>
    </div>

  </div>
</template>

<script>
import {reactive, ref, watch, onMounted} from "vue"
import axios from "axios"
import {onBeforeRouteLeave} from 'vue-router'
import { VDialog } from 'vuetensils/src/components';

import store from "@/store"
import router from "@/router"

import naverLoginComponent from "@/components/naverLoginComponent.vue";
import kakaoLoginComponent from "@/components/kakaoLoginComponent.vue";

import { useRoute } from 'vue-router'

export default {
  name: "TNavComponent",

  components: {
    VDialog,
    naverLoginComponent,
    kakaoLoginComponent
  },

  setup() {
    const route = useRoute()
    const state = reactive({
      form: {
        uid: "",
        upw: "",
        sns_type: ""
      },
      conference_idx : 0
    })

    //메뉴 토글
    const isMenuVisible = ref(false)

    const toggleMenu = () => {
      isMenuVisible.value = !isMenuVisible.value
      // document.body.classList.toggle('fixed', isMenuVisible.value)
    }
    onBeforeRouteLeave(() => {
      //페이지 이동시 isMenuVisible, body fixed 초기화
      isMenuVisible.value = false
      // document.body.classList.remove('fixed');
    })

    //로그인,아웃
    const submit = () => {

      if (!state.form.uid) {
          alert("아이디를 입력하세요.")
          return;
      }
      else if (!state.form.upw) {
        alert("비밀번호를 입력하세요.")
        return;
      }
      else{
        axios.post('/api/account/login', state.form).then((res) => {
          console.log(res.data);
          if(res.data.err_code == 0){ //로그인 성공일 경우
            // store.commit('setAccount', state.form.uid)
            localStorage.setItem('authorization', res.data.contents.body.accessToken)
            router.go({path: '/'})
          }else{
            alert(res.data.err_msg);
          }
        }).catch(() => {
          alert('아이디 또는 비밀번호를 확인하세요.')
        })
      }
    }

    const logout = () => {
      localStorage.removeItem('authorization')
      store.commit('setAccount', 0)
      store.commit('setLevel', 0)
      store.commit('setUid', '')
      router.push({path: '/home'});
    }

    const cartCount = ref(0);

    const getCart = async () => {
      try {
        const { data, status } = await axios.get('/new_api/customer/cart/v2/count');

        if( status === 200 ){
          if( data.code === "200" ){
            cartCount.value = data.data.amount;
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    onMounted(() => {
      getCart();
    });

    return { cartCount, getCart, state, isMenuVisible, toggleMenu, submit, logout }
  },

  methods : {
    alert_msg(v){
      if(v==1){
        alert("5월2일 화요일 12시에 오픈됩니다!");
      }
      else if( v==2 ){
        alert("서비스 점검 중 입니다. 오후에 다시 접수 부탁 드리겠습니다.");
        return false;
      }
    },

    isMallorMypage(path) {
      return path.startsWith('/mall') || path.startsWith('/mypage');
    }
  },

}
</script>
